import { TAB_PAGES } from "@/lib/tabs/pageDescriptors";
import { buildId, makeTab } from "@/lib/tabs/registryCore";

export const settingsId = () => buildId("settings");
export const settingsTab = () =>
  makeTab({
    descriptor: TAB_PAGES.SettingsPage,
    idParts: ["settings"],
    title: "tabs.settings.settings",
    params: {},
  });

export const landingId = () => buildId("landing");
export const landingTab = (url) =>
  makeTab({
    descriptor: TAB_PAGES.LandingPage,
    idParts: ["landing"],
    title: "tabs.landing",
    params: { url },
  });

const staticTabBuilders = {
  [settingsId()]: () => settingsTab(),
  [landingId()]: () => landingTab(),
};

export default {
  dynamicTabResolvers: [],
  staticTabBuilders,
};
